import { FC, ReactNode, useState, MouseEvent, HTMLAttributes } from 'react';
import { ChevronDown } from '@o2/icons';
import Menu from './Menu';
import Button from './Button';
import { Box } from '@o2/ui';

export interface DropDownButtonProps extends Pick<HTMLAttributes<HTMLButtonElement>, 'title'> {
  label: ReactNode;
  children?: ReactNode;
  /**
   * ID of the Menu holding all the dropdown items, propagated to the DOM as `data-elm`.
   */
  menuElmId?: string;
}

const DropDownButton: FC<DropDownButtonProps> = ({ children, label, menuElmId, ...props }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button onClick={handleClick} {...props}>
        <Box>{label}</Box>
        <ChevronDown
          sx={{ fontSize: 14, transition: 'transform 100ms', transform: `rotate(${open ? '180' : '0'}deg)` }}
        />
      </Button>
      <Menu open={open} anchorEl={anchorEl} onClose={handleClose} data-elm={menuElmId}>
        {children}
      </Menu>
    </>
  );
};

DropDownButton.displayName = 'AppBarInternal.DropDownButton';

export default DropDownButton;
